export const validateUser = ({ isAuthenticated, isVerified, t }) => {
  if (!isAuthenticated) {
    return { isValid: false, error: t('pleaseLoginOrRegisterToBid') }
  }
  if (!isVerified) {
    return { isValid: false, error: t('verifyAccountToBid') }
  }
  return { isValid: true }
}

export const validateBidAmount = ({ amount, minimumBid, maxBiddingLevel, t }) => {
  if (isNaN(amount)) {
    return { isValid: false, error: t('pleaseFillBid', { minimumBid }) }
  }

  if (amount < minimumBid) {
    return { isValid: false, error: t('bidShouldBeMoreThanAmount', { minimumBid }) }
  }

  if (amount > maxBiddingLevel && maxBiddingLevel !== -1) {
    return { isValid: false, error: t('verifyAccountToBidMoreThanAmount', { amount: maxBiddingLevel }) }
  }

  return { isValid: true }
}
